import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

/* COMPONENTS */
import { MainComponent } from './shared/main/main.component';
import { HeaderComponent } from './shared/main/header/header.component';
import { SidebarComponent } from './shared/main/sidebar/sidebar.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { SidebarSkeletonComponent } from './shared/main/sidebar/sidebar.skeleton-loader.component';
import { NotificationsPanelComponent } from './shared/main/header/notifications-panel/notifications-panel.component';
import { NotificationBellComponent } from './shared/main/header/notification-bell/notification-bell.component';
import { NotificationListDrawerComponent } from './pages/notification/notification-list-drawer/notification-list-drawer.component';

/* MODULES */
import { CoreModule } from './core';
import { SharedModule } from './shared/shared.module';
import { MaterialModule } from './material/material.module';
import { UsersSelectorModule } from './modules/users-selector/users-selector.module';
import { CommonModule } from '@angular/common';

/* HELPERS */
import { AuthInterceptor } from './core';
import { MockAPIInterceptor } from './core/interceptors/mock-apis';
import { environment } from '../environments/environment';

/* FIREBASE (compat mode for v7+) */
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAnalyticsModule, CONFIG } from '@angular/fire/compat/analytics';
import { AngularFirePerformanceModule } from '@angular/fire/compat/performance';

import { MainResolver } from './shared/main/main.resolver';
import { AppErrorHandler } from './core/interceptors/app-error-handler';

@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    HeaderComponent,
    SidebarComponent,
    SidebarSkeletonComponent,
    NotificationsPanelComponent,
    NotFoundComponent,
    NotificationBellComponent,
    NotificationListDrawerComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    CoreModule,
    SharedModule,
    MaterialModule,
    UsersSelectorModule,
    // Firebase compat mode imports
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireAnalyticsModule,
    AngularFirePerformanceModule,
    CommonModule
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    { provide: ErrorHandler, useClass: AppErrorHandler },
    { provide: HTTP_INTERCEPTORS, useClass: MockAPIInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: CONFIG, useValue: { send_page_view: false } },
    Title,
    MainResolver
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
